import { StimUnitRateBase } from './base/stim-unit-rate-base';

export class StimUnitRate extends StimUnitRateBase { }